import React from 'react';
import ReactDOM from 'react-dom';

const BaseModal = ({isOpen, children, title, onClose, size = 'modal-lg'}) => {
    // Determine modal size class
    const sizeClass = size ? ` ${size}` : '';
    /* useEffect(() => {
         const originalOverflow = window.getComputedStyle(document.body).overflow;  // Capture the original style
         const originalPaddingRight = window.getComputedStyle(document.body).paddingRight;  // Capture the original padding-right
         console.log(isOpen);
         if (isOpen) {
             document.body.style.overflow = 'hidden';
             document.body.style.paddingRight = '8px';
         } else {
             document.body.style.overflow = originalOverflow;
             document.body.style.paddingRight = originalPaddingRight;
         }

         // Cleanup function
         return () => {
             document.body.style.overflow = originalOverflow;
             document.body.style.paddingRight = originalPaddingRight;
         };
     }, [isOpen]);*/

    if (!isOpen) return null;

    return ReactDOM.createPortal(
        <>
            <div className="modal d-block" tabIndex="-1">
                <div className={`modal-dialog py-5${sizeClass}`}>
                    <div className="modal-content">
                        {(title || onClose) && <div className="modal-header">
                            {title && <h5 className="modal-title">{title}</h5>}
                            {onClose && <button type="button" className="btn-close" onClick={onClose}></button>}
                        </div>}
                        {children}
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show"></div>
        </>,
        document.getElementById('modal-root') // Create a <div> element with this ID in your index.html
    );
};

export default BaseModal;
